<template>
  <j-editable-table ref="editableTable"
                    :loading="loading"
                    :columns="columns"
                    :dataSource="dataSource"
                    :rowNumber="true"
                    :maxHeight="340"
                    :disabled="!actionButton"
                    :disabledRows="{ dbFieldName:'id'}" />
</template>

<script>
import { FormTypes } from '@/utils/JEditableTableUtil'

import { syncAllTable } from '../util/TableUtils'

export default {
  name: 'ForeignKeyTable',
  components: {},
  props: {
    actionButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      dataSource: [],
      columns: [
        {
          title: 'tableHeader.fieldName',
          key: 'dbFieldName',
          // width: '15%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: '',
          placeholder: '',
          props: { 'disabled': true } // 只读
        },
        {
          title: 'tableHeader.fieldRemark',
          key: 'dbFieldTxt',
          // width: '15%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: '',
          placeholder: '',
          props: { 'disabled': true } // 只读
        },
        {
          title: 'tableHeader.mainTableName',
          key: 'mainTable',
          // width: '30%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: ''
        },
        {
          title: 'tableHeader.mainTableFields',
          key: 'mainField',
          // width: '30%',
          width: '200px',
          type: FormTypes.input,
          defaultValue: ''
        }
      ]
    }
  },
  methods: {
    /** 同步列表 */
    async syncTable(table1) {
      await syncAllTable(this, table1)
    }
  }
}
</script>

<style scoped>

</style>